import { Tooltip } from "antd";

interface IBVCustomTooltip {
	children: JSX.Element;
	title: string;
	onClick: () => void;
	disabled?: boolean;
	className?: string;
}

const BVCustomTooltip: React.FC<IBVCustomTooltip> = ({
	children,
	title,
	onClick,
	disabled = false,
	className = ''
}) => {
	const handleClick = () => {
		if (!disabled) {
            onClick();
        }
	};

	return (
		<Tooltip title={title}>
			<span 
				className={className} 
				onClick={handleClick} 
				style={{ cursor: disabled ? 'default' : 'pointer' }}
			>
                {children}
            </span>
		</Tooltip>
	);
};

export default BVCustomTooltip;